<template>
  <v-dialog width="800" v-model="dialog">
    <v-card>
      <v-card-title>
        <div class="d-flex justify-space-between" style="width: 100%">
          <div>
            {{ 'CHỌN KHO, NHẬP SỐ LƯỢNG VÀ NGÀY GIAO HÀNG' }}
          </div>
          <v-icon @click="() => closeDialog()">
            mdi-close
          </v-icon>
        </div>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <div class="inventory__info-basic error--text">
          {{ `${get(product, 'code', '--')} / ${get(product, 'description', '--')}` }}
        </div>
        <v-divider />
        <div class="inventory__content" v-if="product.inventories">
          <div v-for="(inventory, index) in product.inventories" :key="index">
            <div>
              <FormInventory
                :inventory="inventory"
                :totalQuantity="inventory.totalQuantity"
                :ref="`inventory-${inventory._id}`"
              />
              <v-divider class="mt-6" v-if="index !== product.inventories.length - 1" />
            </div>
          </div>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions class="py-4 px-8">
        <v-spacer />
        <v-btn color="primary" class="text-none" @click="onSave">
          {{ 'Cập nhật thông tin' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import FormInventory from './FormInventory.vue'
import { mapState, mapActions } from 'vuex'
import { get, groupBy } from 'lodash'
import alert from '@/plugins/alert'
export default {
  name: 'PopupEditInventory',
  components: {
    FormInventory
  },
  data() {
    return {
      dialog: false,
      loading: false,
      product: {},
      data: null,
      get
    }
  },
  computed: {
    ...mapState({
      delivery(state) {
        return state['importDeliveries'].item
      }
    })
  },
  methods: {
    ...mapActions({
      saveSchedule: 'importDeliveries/saveSchedule',
      fetchItem: 'importDeliveries/fetchOne'
    }),
    openDialog(data) {
      this.data = data
      const groupInventory = this.groupObjectsByInventory(data.inventories)
      const mapData = groupInventory.map(item => {
        const product = item[0]
        const schedules = item
          .map(i => {
            if (!i.deliveredAt) return
            return {
              ...i
            }
          })
          .filter(Boolean)
        return {
          ...product,
          quantity: schedules.reduce((acc, cur) => acc + cur.quantity, 0),
          schedules
        }
      })
      this.product = {
        ...data,
        inventories: mapData
      }
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.product = {}
    },
    groupObjectsByInventory(inputArray) {
      const groupedArrays = groupBy(inputArray, 'inventory')
      const resultArray = Object.values(groupedArrays)
      return resultArray
    },
    async onSave() {
      let errorItem = []
      try {
        this.$loading.active = true
        const importDeliveryId = get(this.delivery, 'id')
        if (!importDeliveryId) return alert.error('Đã có lỗi xảy ra (importOrderId missing)')
        const data = this.product.inventories
          .map(inventory => {
            const ref = `inventory-${inventory._id}`
            const getData = this.$refs[ref][0].getData()
            if (getData === false) return errorItem.push(get(inventory, 'name', ''))
            if (getData) {
              return {
                ...inventory,
                schedules: getData,
                id: inventory._id
              }
            }
            return { ...inventory, id: inventory._id }
          })
          .filter(Boolean)
        if (errorItem.length) {
          return this.$alert.error(`Vui lòng điền lịch ngày giao hàng vào kho: ${errorItem.join(', ')}`)
        }
        errorItem = []
        const params = {
          importDelivery: importDeliveryId,
          productModel: this.product.id,
          listData: data
        }
        await this.saveSchedule(params)
        await this.fetchItem(get(this.delivery, 'id'))
        this.dialog = false
        this.$emit('onRefresh')
        alert.success('Cập nhật thành công!')
      } catch (error) {
        this.$alert.error(error.message)
        this.openDialog(this.data)
        return
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.inventory__info-basic {
  font-size: 20px;
  padding: 24px 0;
}
.inventory__content {
  max-height: 55vh;
  overflow-y: auto;
}
</style>
